import React from "react";
import { SvgIcon } from "@mui/material";
import styles from "../../icons/iconStyles";

const ShieldStarIcon = (props: any) => {
  const styles = {
    icon: {
      height: 16,
      width: 16
    }
  };
  return (
    <SvgIcon style={styles.icon} >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.01958 5.36719L8.74789 6.89318L10.3849 7.13595L9.19875 8.32899L9.48314 10.0006L8.01958 9.20991L6.55602 10.0006L6.84041 8.32899L5.6543 7.13595L7.29127 6.89318L8.01958 5.36719Z"
          stroke="#747881"
          strokeMiterlimit="10"
        />
        <path
          d="M8.02032 15.3006C8.02032 15.3006 13.9786 13.3169 13.9786 10.0013C13.9786 8.01751 13.3197 8.01751 13.3197 6.03372C13.3031 4.89444 13.5277 3.76453 13.9786 2.71816L13.3197 1.39332H10.67C9.75162 1.35288 8.85066 1.12882 8.02032 0.734375C7.1925 1.14081 6.29143 1.37669 5.37065 1.42801H2.72098L2.02734 2.75284C2.4902 3.79661 2.7266 4.92662 2.72098 6.0684C2.72098 8.05219 2.02734 8.05219 2.02734 10.036C2.06203 13.3169 8.02032 15.3006 8.02032 15.3006Z"
          stroke="#747881"
          strokeMiterlimit="10"
        />
      </svg>
    </SvgIcon>
  );
};

export default ShieldStarIcon;
